import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromCompetition from '../competition/competition.reducer'
import { CompetitionRoutingModule } from './competition-routing.module'
import { CompetitionEffects } from './competition.effects'
import { CompetitionSerializer } from './competition.serializer'
import { CompetitionService } from './competition.service'
import { DocumentModule } from '../document/document.module'
import { CompetitionIndexComponent } from './index/index.component'
import { CompetitionTeamModule } from './competition-team/competition-team.module'
import { CompetitionMatchModule } from './competition-match/competition-match.module'
import { CompetitionLevelModule } from './competition-level/competition-level.module'
import { CompetitionStaffModule } from './competition-staff/competition-staff.module'
import { CompetitionPlayerModule } from './competition-player/competition-player.module'
import { CompetitionMatchEventModule } from './competition-match-event/competition-match-event.module'
import { CompetitionSportModule } from './competition-sport/competition-sport.module'
import { CompetitionPoolModule } from './competition-pool/competition-pool.module'
import { CompetitionStaffFunctionModule } from './competition-staff-function/competition-staff-function.module'
import { CompetitionDetailsComponent } from './competition-team/competition-details/competition-details.component'

@NgModule({
    imports: [
        CommonModule,
        CompetitionRoutingModule,
        SharedModule,
        StoreModule.forFeature(fromCompetition.FEATURE_NAME, fromCompetition.competitionReducer),
        EffectsModule.forFeature([CompetitionEffects]),
        DocumentModule,
        CompetitionTeamModule,
        CompetitionMatchModule,
        CompetitionLevelModule,
        CompetitionStaffModule,
        CompetitionPlayerModule,
        CompetitionMatchEventModule,
        CompetitionSportModule,
        CompetitionPoolModule,
        CompetitionStaffFunctionModule
    ],
    providers: [
        CompetitionService,
        {
            provide: CompetitionSerializer,
            useClass: CompetitionSerializer
        }
    ],
    declarations: [CompetitionIndexComponent, CompetitionDetailsComponent],
    exports: []
})
export class CompetitionModule {}
